/**
 * Home Screen Styles
 * 
 * Extracted to keep screen file under 300 lines per cursor rules.
 * Uses design tokens exclusively.
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, touch, layout, icon } from '../../../shared/tokens/mobile';

export const homeStyles = StyleSheet.create({
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: space.md,
    paddingTop: space.md,
    paddingBottom: layout.scrollBottomPadding,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: space.md,
  },
  loadingText: {
    fontSize: text.body.fontSize,
    color: color.textSecondary,
  },

  // Header
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: space.lg,
  },
  headerText: {
    flex: 1,
  },
  greeting: {
    fontSize: text.body.fontSize,
    fontWeight: text.body.fontWeight,
    lineHeight: text.body.lineHeight,
    color: color.textSecondary,
  },
  userName: {
    fontSize: text.pageTitle.fontSize,
    fontWeight: text.pageTitle.fontWeight,
    lineHeight: text.pageTitle.lineHeight,
    letterSpacing: text.pageTitle.letterSpacing,
    color: color.textPrimary,
    marginTop: space.xs,
  },
  avatar: {
    width: touch.minimum,
    height: touch.minimum,
    borderRadius: radius.full,
    backgroundColor: color.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarInitial: {
    fontSize: text.cardTitle.fontSize,
    fontWeight: text.cardTitle.fontWeight,
    color: color.textInverse,
  },

  // Error
  errorCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: color.errorLight,
    borderRadius: radius.md,
    padding: space.md,
    marginBottom: space.lg,
    gap: space.sm,
  },
  errorText: {
    flex: 1,
    fontSize: text.body.fontSize,
    color: color.error,
  },
  retryButton: {
    paddingHorizontal: space.sm,
    paddingVertical: space.xs,
    backgroundColor: color.error,
    borderRadius: radius.sm,
  },
  retryText: {
    fontSize: text.caption.fontSize,
    color: color.surface,
    fontWeight: '600',
  },

  // Sections
  section: {
    marginBottom: space.lg,
  },

  // Empty states
  emptyCard: {
    backgroundColor: color.backgroundSecondary,
    borderRadius: radius.lg,
    padding: space.lg,
    alignItems: 'center',
    gap: space.sm,
  },
  emptyText: {
    fontSize: text.body.fontSize,
    color: color.textMuted,
  },
  addButton: {
    marginTop: space.sm,
    paddingHorizontal: space.md,
    paddingVertical: space.sm,
    backgroundColor: color.primary,
    borderRadius: radius.md,
  },
  addButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
});

